// extracted by mini-css-extract-plugin
export var divider = "_mt-0";
export var systemMessage = "_mt-1";
export var systemMessageWrapper = "_mt-2";